// extracted by mini-css-extract-plugin
module.exports = {"main_container":"HiringCompleted_main_container_2RnWL","show-label":"HiringCompleted_show-label_31iAn"};